export const getFees = (obj: any, name: string) => {
  return Object.keys(obj)
    .filter((key) => key.includes(name))
    .reduce((cur, key) => {
      return Object.assign(cur, obj[key].fees)
    }, {})
}
